<template>
  <div class="text-left mb-15 registerForm">
    <el-form ref="registerForm" :model="register" :rules="registerRules">
      <div v-if="isModal">
        <el-row v-if="isModal">
          <el-form-item prop="firstName" class="mb-5">
            <el-input
              v-model="register.firstName"
              :placeholder="$t('users.label.firstName')"
            />
          </el-form-item>
        </el-row>
        <el-row v-if="isModal">
          <el-form-item prop="lastName" class="mb-5">
            <el-input
              v-model="register.lastName"
              :placeholder="$t('users.label.lastName')"
            />
          </el-form-item>
        </el-row>
      </div>
      <div v-else class="mb-1">
        <el-row :gutter="10">
          <el-col :xs="12" :sm="12" :md="12">
            <el-form-item prop="firstName">
              <el-input
                class="register-input"
                v-model="register.firstName"
                :placeholder="$t('users.label.firstName')"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="!isModal" :xs="12" :sm="12" :md="12">
            <el-form-item prop="lastName">
              <el-input
                class="register-input"
                v-model="register.lastName"
                :placeholder="$t('users.label.lastName')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col>
          <el-form-item prop="email">
            <el-input
              class="register-input"
              v-model="register.email"
              prop="email"
              :placeholder="$t('users.label.email')"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="password">
            <el-input
              :type="passwordInputTypeReg"
              v-model="register.password"
              :placeholder="$t('users.label.password')"
              class="show-password register-input"
            >
              <img
                slot="suffix"
                :src="eyeSolidReg"
                v-if="passwordInputTypeReg === 'password'"
                class="el-input__icon password-icon-class-register"
                @click="changesPasswordInputType('text')"
              />
              <img
                slot="suffix"
                :src="eyeSlashSolidReg"
                v-else
                class="el-input__icon password-icon-class-register"
                @click="changesPasswordInputType('password')"
              />
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isModal" class="mt-0">
        <el-checkbox v-model="register.newsletter" class="remember-me">
          {{ $t("users.registration.label.consent") }}
        </el-checkbox>
      </el-row>
      <el-row :class="[isModal ? 'text-left' : ctaCustomClass]">
        <el-button
          type="primary"
          native-type="submit"
          class="ctaSubmit"
          @click="handleAccountCreation"
        >
        {{ $t("shoppingCart.shoppingCartAuthModel.continue") }}
        </el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "@/utils/lodash";
import { getPortausCompanyId } from "@/utils/market-utils";
import userApiReq from "@/api/user";
import eyeSolid from "@/assets/images/icons/password/eye-solid.svg";
import eyeSlashSolid from "@/assets/images/icons/password/eye-slash-solid.svg";

export default {
  components: {},
  props: {
    redirectPath: {
      type: String,
      default: null,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    ctaSubmitText: {
      type: String,
      default: null,
    },
    toggleResetFields: {
      type: Boolean,
      default: false,
    },
    ctaCustomClass: {
      type: String,
      default: "text-right mt-15",
    },
  },
  data() {
    return {
      register: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        newsletter: null,
      },
      registerRules: {
        firstName: [
          {
            required: true,
            message: this.$i18n.t("checkout.from.firstName"),
            trigger: "blur",
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$i18n.t("checkout.from.lastName"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t("checkout.from.email"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$i18n.t("checkout.from.password"),
            trigger: "blur",
          },
        ],
      },
      passwordInputTypeReg: "password",
      eyeSolidReg: eyeSolid,
      eyeSlashSolidReg: eyeSlashSolid,
    };
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),
    country() {
      return get(this.actionBar, "country");
    },
  },
  watch: {
    toggleResetFields() {
      this.resetFields();
    },
  },
  methods: {
    resetFields() {
      this.$refs.registerForm.resetFields();
    },
    handleAccountCreation(e) {
      const vm = this;
      e.preventDefault();
      vm.$refs.registerForm.validate().then((valid) => {
        if (valid) {
          // Real company for the customer record — never the browsing override.
          this.register.portausCompanyId = getPortausCompanyId(this.country);
          const userKey = `newsletter_${this.register.email}`;
          localStorage.setItem(userKey, this.register.newsletter);
          return userApiReq
            .create(vm.register)
            .then((userId) => {
              if (userId != null) {
                if (vm.redirectPath) {
                  vm.$router.push(vm.redirectPath);
                } else {
                  vm.$emit("show-confirmation");
                  vm.resetFields();
                }
              } else {
                vm.$emit("error", "cannot register user");
              }
            })
            .catch((error) => {
              vm.$emit("error", error);
            });
        }
        return null;
      });
    },
    changesPasswordInputType(type) {
      this.passwordInputTypeReg = type;
    },
  },
};
</script>

<style scoped>
.ctaSubmit {
  width: 150px;
  height: 40px;
}
.password-icon-class-register {
  cursor: pointer;
  width: 20px;
  margin-right: 10px;
}
.register-input .el-input__inner {
  margin: 0px !important;
}
.remember-me {
  white-space: normal;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
